import { ChangeDetectionStrategy, Component } from '@angular/core';
import { JsonLdService, MetaService } from '@app/core';
import { AppIconSectionComponent, CtaSectionComponent } from '@app/widgets';
import { PRICING_FAQS } from '../../constants';
import { PricingFaqSectionComponent } from '../pricing-faq-section/pricing-faq-section.component';
import { PricingHeroSectionComponent } from '../pricing-hero-section/pricing-hero-section.component';
import { PricingPlansSectionComponent } from '../pricing-plans-section/pricing-plans-section.component';
import { PricingPromiseSectionComponent } from '../pricing-promise-section/pricing-promise-section.component';

@Component({
  selector: 'app-pricing',
  imports: [
    AppIconSectionComponent,
    CtaSectionComponent,
    PricingFaqSectionComponent,
    PricingHeroSectionComponent,
    PricingPlansSectionComponent,
    PricingPromiseSectionComponent,
  ],
  templateUrl: './pricing.component.html',
  styleUrl: './pricing.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PricingComponent {
  constructor(
    private readonly metaService: MetaService,
    private readonly jsonLdService: JsonLdService,
  ) {
    this.metaService.setDescription(
      "Discover Capawesome Cloud's pricing plans designed for every stage of your app's growth. From free to enterprise, find the perfect fit for your needs.",
    );
    this.metaService.setTitle('Pricing Plans for Capacitor Teams');
    this.metaService.setKeywords([
      'Capacitor cloud pricing',
      'live updates pricing',
      'native builds pricing',
    ]);
    this.jsonLdService.setStructuredData([
      JsonLdService.buildWebPageSchema(
        'Pricing - Capawesome Cloud',
        "Discover Capawesome Cloud's pricing plans designed for every stage of your app's growth.",
        'https://cloud.capawesome.io/pricing/',
      ),
      JsonLdService.buildFaqSchema(PRICING_FAQS),
    ]);
  }
}
